import { IBasePropertyDTO } from 'business/models/Models';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import SwitchButton from 'components/customComponents/Controls/SwitchButton';
import { RMColorPicker } from 'components/main/GlobalPrefrences/GlobalPrefrences';
import { RMInput } from 'components/main/ProteinFormulation/RMInput';
import { PropertyDiscriminator } from 'enums/DispensingPropertiesConstants';
import React, { useMemo } from 'react';
interface Props {
  property: IBasePropertyDTO;
  robotId: number;
  plateId?: number;
  liquidClassId?: number;
  onChangeProp?: (
    property,
    e,
    robotId: number,
    plateId?: number,
    liquidClassId?: number,
  ) => void;
}

const PropertyView = (props: Props) => {
  const { property, robotId, plateId, liquidClassId, onChangeProp } = props;

  if (!property) {
    return;
  }

  const dbListOptions = useMemo(() => {
    return property['options']?.map((opt) => {
      return { id: parseInt(opt.name), name: opt.displayName };
    });
  }, [property]);

  const listEnumOptions = useMemo(() => {
    return property['options']?.map((opt) => {
      return { id: opt.id, name: opt.displayName };
    });
  }, [property]);

  switch (property['discriminator']) {
    case PropertyDiscriminator.DBListPropertyDTO:
    case PropertyDiscriminator.ListPropertyDTO:
      return (
        <RMSelect
          key={property.name}
          className="flex-50"
          style={{ height: '2rem' }}
          options={dbListOptions}
          selectedValue={parseInt(property['value'].name)}
          onChange={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
          placeholder={'any'}
          disabled={false}
        />
      );
    case PropertyDiscriminator.ListEnumDTO:
      return (
        <RMSelect
          key={property.name}
          className="flex-50"
          style={{ height: '2rem' }}
          options={listEnumOptions}
          selectedValue={property['value'].id}
          onChange={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
          placeholder={'any'}
          disabled={false}
        />
      );
    case PropertyDiscriminator.StringPropertyDTO:
      return (
        <input
          id={`propertyview-stringproperty-${property.name}`}
          key={property.name}
          className="inputFieldDetails flex-50"
          type="text"
          onChange={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
          value={property['value']}
        />
      );
    case PropertyDiscriminator.IntPropertyDTO:
    case PropertyDiscriminator.LongPropertyDTO:
    case PropertyDiscriminator.DoublePropertyDTO:
    case PropertyDiscriminator.FloatPropertyDTO:
      return (
        <RMInput
          key={property.name}
          className="inputFieldDetails flex-50"
          onChange={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
          value={property['value']}
          allowDecimals={
            property['discriminator'] === PropertyDiscriminator.DoublePropertyDTO ||
            property['discriminator'] === PropertyDiscriminator.FloatPropertyDTO
          }
        />
      );
    case PropertyDiscriminator.BooleanPropertyDTO:
      return (
        <div id={`propertyview-booleanproperty-${property.name}`} className="flex-50">
          <SwitchButton
            key={property.name}
            onToggle={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
            isOn={property['value']}
          />
        </div>
      );
    case PropertyDiscriminator.ColorPropertyDTO:
      return (
        <RMColorPicker
          className="flex-50"
          key={property.name}
          color={property['value']}
          onChange={(e) => onChangeProp(property, e, robotId, plateId, liquidClassId)}
        />
      );
    default:
      return <div>Nothing</div>;
  }
};

export default PropertyView;
